import { Box, Button, Card, Tab, Table, TabList, TabPanel, Tabs, Typography } from '@mui/joy';
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { post, Token } from '../../../../../Script/Session';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
function FilePrüfer() {

    const { fileid, dateiname, subkath, perms, type,stand } = useParams();
    const [value, setValue] = React.useState(0);
    const [data, setdata] = useState();
    const navigate = useNavigate();
    const handleChange = (event, newValue) => {
        if (newValue == 1) {
            window.open('', '_self'); // öffnet eine leere Seite im selben Tab
            window.close();
        }
        setValue(newValue);
    };
    useEffect(() => {
        const fetchVereinData = async () => {
            const body = {
                token: Token.get(),
                action: "get",
                targetfileid: fileid,
                subkath: Number(subkath),
                type: type,
            };

            try {
                let response = await post(body, "/prüfung/file");
                if (response === "LOGOUT") {
                    navigate("/");
                    return;
                }

                setdata(JSON.parse(response));
                console.log("Debug!! " + response);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        setTimeout(() => {
            fetchVereinData();
        }, 15);

    }, []);
    function update(){
            const body = {
                token: Token.get(),
                action: "get",
                targetfileid: fileid,
                subkath: Number(subkath),
                type: type,
            };

            try {
                let response = post(body, "/prüfung/file");
                if (response === "LOGOUT") {
                    navigate("/");
                    return;
                }

                setdata(JSON.parse(response));
                console.log("Debug!! " + response);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
    }
    function remove(stamp){
            const body = {
                token: Token.get(),
                action: "delete",
                targetfileid: fileid,
                subkath: Number(subkath),
                type: type,
                stamp: stamp,
                dateiname: dateiname,
                tarifstand: Number(stand),
            };
            let response = post(body, "/prüfung/file");
            if (response == "LOGOUT"){
                navigate("/");
            }
            if (response == "OK"){
                update();
            }
    }
    function add(){
            const body = {
                token: Token.get(),
                action: "create",
                targetfileid: fileid,
                subkath: Number(subkath),
                dateiname: dateiname,
                tarifstand: Number(stand),
            };
            let response = post(body, "/prüfung/file");
            if (response == "LOGOUT"){
                navigate("/");
            }
            if (response == "OK"){
                update();
            }
    }
    return (
        <>
            <Tabs
                orientation="vertical"
                variant="scrollable"
                value={value}
                onChange={handleChange}
                aria-label="Vertical tabs example"
                sx={{ borderRight: 1, borderColor: 'divider', width: "100%", minHeight: "100vh" }}
            >
                <TabList>
                    <Tab>Prüfungsübersicht</Tab>
                    <Tab sx={{ color: "red" }}>Schliesen</Tab>
                </TabList>
                <TabPanel value={0}>
                    {
                        data && !data.prüfungaktuell && (
                            <Card variant='solid' sx={{ bgcolor: "#c8e6c9", display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                <Box>
                                    <Typography level="title-md">Datei ist Geprüft!</Typography>
                                    <Typography>Die letzte prüfung ist noch im erforderlichen zeitraum erfolgt</Typography>
                                </Box>
                                {
                                    perms && (
                                        <Button sx={{ height: "5%" }} color="success" onClick={() => add()}>Trozdem Prüfen</Button>
                                    )
                                }

                            </Card>


                        )
                    }
                    {
                        data && data.prüfungaktuell && (
                            <Card variant='solid' sx={{ bgcolor: "#ffcdd2", display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                <Box>
                                    <Typography level="title-md">Datei ist Geprüft!</Typography>
                                    <Typography>Die letzte prüfung ist noch im erforderlichen zeitraum erfolgt</Typography>
                                </Box>
                                {
                                    perms && (
                                        <Button sx={{ height: "5%" }} onClick={() => add()} color="danger">Prüfen</Button>
                                    )
                                }

                            </Card>

                        )
                    }
                    <Table>
                        <thead>
                            <tr>
                                <th>Datum</th>
                                <th>Prüfer</th>
                                {perms && (
                                    <th>Beatbeiten</th>
                                )}
                            </tr>
                        </thead>
                        <tbody>
                            {data && data.result.slice().sort((a,b) => b.stamp - a.stamp).map((item) => {
                                return (
                                    <tr key={item.stamp}>
                                        <td>{item.time.split(":")[0]}:{item.time.split(":")[1]}</td>
                                        <td>{item.name}</td>
                                        {perms && (
                                            <td>
                                                <Button
                                                    variant="soft"
                                                    color="danger"
                                                    startDecorator={<DeleteForeverOutlinedIcon />}
                                                    onClick={() => remove(item.stamp)}
                                                >
                                                    Löschen
                                                </Button></td>
                                        )}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table>
                </TabPanel>
            </Tabs>

        </>
    )
}

export default FilePrüfer
